import { setDoc, doc } from 'firebase/firestore';
import { ref, uploadString, getDownloadURL } from 'firebase/storage';

export const safeWrite = async (ref: any, data: any) => {
  setDoc(ref, data).catch(console.error);
};

export const uploadImage = async (storage: any, base64: string, path: string): Promise<string> => {
  if (!base64 || !base64.startsWith('data:image')) return base64;
  try {
    const storageRef = ref(storage, path);
    await uploadString(storageRef, base64, 'data_url');
    return await getDownloadURL(storageRef);
  } catch (e) {
    return base64;
  }
};

export const handleLoadError = (error: any): { isConnected: boolean; lastError: string | null } => {
  let lastError = null;
  if (error.message?.includes('Cloud Firestore API has not been used')) {
    lastError = "BANCO DE DADOS NÃO CRIADO.";
  }
  return { isConnected: false, lastError };
};
